import React from 'react';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
import { AnimatedSection } from './ui/AnimatedSection';
export function Pricing() {
  return <AnimatedSection id="pricing" className="py-24 bg-brand-surface border-y border-brand-border" data-id="element-176">
      <div className="container mx-auto px-4 md:px-6" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-179">
            ELEGÍ TU MEGA PACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-180">
          {/* Standard Tier */}
          <div className="bg-brand-dark border border-brand-border rounded-2xl p-8 flex flex-col relative" data-id="element-181">
            <div className="mb-8" data-id="element-182">
              <div className="text-4xl mb-4" data-id="element-183">📘</div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-184">
                MEGA PACK MONOCICLO
              </h3>
              <p className="text-brand-yellow font-medium mb-4" data-id="element-185">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-zinc-400 text-sm h-12" data-id="element-186">
                Para el rider que quiere dominar el mantenimiento y dejar de
                depender del service
              </p>
            </div>

            <div className="mb-8" data-id="element-187">
              <div className="text-zinc-500 line-through text-xl mb-1" data-id="element-188">
                $45.000
              </div>
              <div className="text-5xl font-bold text-white mb-2" data-id="element-189">
                $19.990{' '}
                <span className="text-xl text-zinc-400 font-normal" data-id="element-190">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-191">
              <Button fullWidth size="lg" variant="outline" className="mb-4" onClick={() => window.open('https://www.soportesaberdigital.com/cart/48947971293423:1', '_blank')} data-id="element-192">
                → QUIERO MI MEGA PACK
              </Button>
            </div>
          </div>

          {/* Pro Tier */}
          <div className="bg-brand-dark border-2 border-brand-yellow rounded-2xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(250,204,21,0.15)]" data-id="element-193">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-yellow text-brand-dark font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 whitespace-nowrap" data-id="element-194">
              <Star className="w-4 h-4 fill-current" data-id="element-195" />
              MÁS VENDIDO
            </div>

            <div className="mb-8" data-id="element-196">
              <div className="text-4xl mb-4" data-id="element-197">🏆</div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-198">
                MEGA PACK + CONFIGURACIÓN PRO
              </h3>
              <p className="text-brand-yellow font-medium mb-4" data-id="element-199">
                6 Tomos + 6 Bonos + Manual de Tuning y Performance Extrema
              </p>
              <p className="text-zinc-400 text-sm h-12" data-id="element-200">
                Para el rider que quiere ir más allá del mantenimiento y
                desbloquear el rendimiento real de su rueda
              </p>
            </div>

            <div className="mb-8" data-id="element-201">
              <div className="text-zinc-500 line-through text-xl mb-1" data-id="element-202">
                $65.000
              </div>
              <div className="text-5xl font-bold text-white mb-2" data-id="element-203">
                $27.990{' '}
                <span className="text-xl text-zinc-400 font-normal" data-id="element-204">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-205">
              <Button fullWidth size="lg" className="mb-4 animate-pulse-slow" onClick={() => window.open('https://www.soportesaberdigital.com/cart/48948441252079:1', '_blank')} data-id="element-206">
                → QUIERO EL MEGA PACK + PRO
              </Button>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}